exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".el-menu-demo[data-v-6bdadb6b]{display:flex;width:100%}.scrollStyle[data-v-6bdadb6b]{width:100%}\n", ""]);

// exports
